module.exports = __webpack_public_path__ + "img/h-2.71ca443e.png";